<!--
 * @Author: Hyman Choi
 * @Date: 2021-01-11 10:25:08
 * @LastEditTime: 2021-01-14 16:06:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\views\contactUs\index.vue
-->
<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="box-card left">
          <h2>汕头超声仪器研究股份有限公司</h2>
          <div>地址：广东省汕头市金砂路77号</div>
          <div>邮编：515041</div>
          <div>电话: 0754-88250150</div>
          <div>传真：0754-88603664</div>
          <div>电子邮箱：siui@siui.com</div>
          <div>新浪/腾讯微博：@SIUI汕头超声</div>
          <div>微信公众账号：SIUI汕头超声</div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card right">
          <h2>关注我们</h2>
          <img
            src="http://www.siui.com.cn/stscsy201605251855/uploadfiles/2016/12/201612261415261526.jpg"
            width="400px"
          >
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 500px;

  div {
    width: 240px;
    height: 40px;
    line-height: 40px;
  }
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 500px;
}
</style>
